import * as yup from "yup";
import { ASSESSMENT_FORM_ENUMS } from "./form.util";

export const validationAssessmentSchema = yup.object().shape({
  [ASSESSMENT_FORM_ENUMS.rating]: yup
    .number()
    .min(1, "Por favor, selecciona una puntuación")
    .max(3, "Por favor, selecciona una puntuación")
    .required("Por favor, selecciona una puntuación"),
  [ASSESSMENT_FORM_ENUMS.comment]: yup.string().when(ASSESSMENT_FORM_ENUMS.rating, {
    is: 3,
    then: () =>
      yup
        .string()
        .required("Por favor, escribe un comentario e indica por qué")
        .min(15, "Por favor, escribe un comentario e indica por qué"),
    otherwise: () => yup.string().nullable()
  })
});
